<template lang="pug">
.v-modal-success.modal-success(v-if="data" )
	h1(v-if="data.note" ) {{ data.note }}

</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},
	}
};
</script>
